import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, PushSubscribeResult} from "../schema"

import {MutationPushSubscribeArgs} from "../schema"

export type MutationPushSubscribeVars = MutationPushSubscribeArgs

export function pushSubscribeMutation(mutation: MutationGenqlSelection['push_subscribe'] | null) {            
    return {
      build: (variables: MutationPushSubscribeVars) => genqlBuilder.build(mutation ? {push_subscribe: mutation} : {__scalar: true}, {push_subscribe: variables}),  
      mutate: (variables: MutationPushSubscribeVars) => ({} as Promise<PushSubscribeResult>),
      _variables: {} as MutationPushSubscribeVars,
      _result: {} as PushSubscribeResult,
    }
}

export type MutationPushSubscribe = {
  builder: (variables: MutationPushSubscribeVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['push_subscribe'],
  variables: MutationPushSubscribeVars,
  result: PushSubscribeResult
}

export default pushSubscribeMutation